// source: exQryHolds.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.common.model.ExHolds', null, global);
goog.exportSymbol('proto.common.model.ExHolds.Data', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.model.ExHolds = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.common.model.ExHolds.repeatedFields_, null);
};
goog.inherits(proto.common.model.ExHolds, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.model.ExHolds.displayName = 'proto.common.model.ExHolds';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.model.ExHolds.Data = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.model.ExHolds.Data, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.model.ExHolds.Data.displayName = 'proto.common.model.ExHolds.Data';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.common.model.ExHolds.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.model.ExHolds.prototype.toObject = function(opt_includeInstance) {
  return proto.common.model.ExHolds.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.model.ExHolds} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExHolds.toObject = function(includeInstance, msg) {
  var f, obj = {
exchange: jspb.Message.getFieldWithDefault(msg, 1, 0),
dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.common.model.ExHolds.Data.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.model.ExHolds}
 */
proto.common.model.ExHolds.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.model.ExHolds;
  return proto.common.model.ExHolds.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.model.ExHolds} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.model.ExHolds}
 */
proto.common.model.ExHolds.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExchange(value);
      break;
    case 2:
      var value = new proto.common.model.ExHolds.Data;
      reader.readMessage(value,proto.common.model.ExHolds.Data.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.model.ExHolds.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.model.ExHolds.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.model.ExHolds} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExHolds.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExchange();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.common.model.ExHolds.Data.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.model.ExHolds.Data.prototype.toObject = function(opt_includeInstance) {
  return proto.common.model.ExHolds.Data.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.model.ExHolds.Data} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExHolds.Data.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
symbol: jspb.Message.getFieldWithDefault(msg, 2, ""),
holdid: jspb.Message.getFieldWithDefault(msg, 3, ""),
holdside: jspb.Message.getFieldWithDefault(msg, 4, ""),
holdprice: jspb.Message.getFieldWithDefault(msg, 5, ""),
holdsz: jspb.Message.getFieldWithDefault(msg, 6, ""),
openbal: jspb.Message.getFieldWithDefault(msg, 7, ""),
holdbal: jspb.Message.getFieldWithDefault(msg, 8, ""),
ccy: jspb.Message.getFieldWithDefault(msg, 9, ""),
ctime: jspb.Message.getFieldWithDefault(msg, 10, ""),
utime: jspb.Message.getFieldWithDefault(msg, 11, ""),
mgnmode: jspb.Message.getFieldWithDefault(msg, 12, ""),
leverage: jspb.Message.getFieldWithDefault(msg, 13, ""),
liqprice: jspb.Message.getFieldWithDefault(msg, 14, ""),
notional: jspb.Message.getFieldWithDefault(msg, 15, ""),
unrealizedprofit: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.model.ExHolds.Data}
 */
proto.common.model.ExHolds.Data.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.model.ExHolds.Data;
  return proto.common.model.ExHolds.Data.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.model.ExHolds.Data} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.model.ExHolds.Data}
 */
proto.common.model.ExHolds.Data.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHoldid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setHoldside(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setHoldprice(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setHoldsz(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpenbal(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setHoldbal(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCcy(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCtime(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setUtime(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setMgnmode(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeverage(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setLiqprice(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setNotional(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnrealizedprofit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.model.ExHolds.Data.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.model.ExHolds.Data.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.model.ExHolds.Data} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExHolds.Data.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHoldid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getHoldside();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHoldprice();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getHoldsz();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOpenbal();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getHoldbal();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCcy();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCtime();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getUtime();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getMgnmode();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getLeverage();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getLiqprice();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getNotional();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getUnrealizedprofit();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.common.model.ExHolds.Data.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExHolds.Data} returns this
 */
proto.common.model.ExHolds.Data.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string symbol = 2;
 * @return {string}
 */
proto.common.model.ExHolds.Data.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExHolds.Data} returns this
 */
proto.common.model.ExHolds.Data.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string holdId = 3;
 * @return {string}
 */
proto.common.model.ExHolds.Data.prototype.getHoldid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExHolds.Data} returns this
 */
proto.common.model.ExHolds.Data.prototype.setHoldid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string holdSide = 4;
 * @return {string}
 */
proto.common.model.ExHolds.Data.prototype.getHoldside = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExHolds.Data} returns this
 */
proto.common.model.ExHolds.Data.prototype.setHoldside = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string holdPrice = 5;
 * @return {string}
 */
proto.common.model.ExHolds.Data.prototype.getHoldprice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExHolds.Data} returns this
 */
proto.common.model.ExHolds.Data.prototype.setHoldprice = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string holdSz = 6;
 * @return {string}
 */
proto.common.model.ExHolds.Data.prototype.getHoldsz = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExHolds.Data} returns this
 */
proto.common.model.ExHolds.Data.prototype.setHoldsz = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string openBal = 7;
 * @return {string}
 */
proto.common.model.ExHolds.Data.prototype.getOpenbal = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExHolds.Data} returns this
 */
proto.common.model.ExHolds.Data.prototype.setOpenbal = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string holdBal = 8;
 * @return {string}
 */
proto.common.model.ExHolds.Data.prototype.getHoldbal = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExHolds.Data} returns this
 */
proto.common.model.ExHolds.Data.prototype.setHoldbal = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string ccy = 9;
 * @return {string}
 */
proto.common.model.ExHolds.Data.prototype.getCcy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExHolds.Data} returns this
 */
proto.common.model.ExHolds.Data.prototype.setCcy = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string cTime = 10;
 * @return {string}
 */
proto.common.model.ExHolds.Data.prototype.getCtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExHolds.Data} returns this
 */
proto.common.model.ExHolds.Data.prototype.setCtime = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string uTime = 11;
 * @return {string}
 */
proto.common.model.ExHolds.Data.prototype.getUtime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExHolds.Data} returns this
 */
proto.common.model.ExHolds.Data.prototype.setUtime = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string mgnMode = 12;
 * @return {string}
 */
proto.common.model.ExHolds.Data.prototype.getMgnmode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExHolds.Data} returns this
 */
proto.common.model.ExHolds.Data.prototype.setMgnmode = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string leverage = 13;
 * @return {string}
 */
proto.common.model.ExHolds.Data.prototype.getLeverage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExHolds.Data} returns this
 */
proto.common.model.ExHolds.Data.prototype.setLeverage = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string liqPrice = 14;
 * @return {string}
 */
proto.common.model.ExHolds.Data.prototype.getLiqprice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExHolds.Data} returns this
 */
proto.common.model.ExHolds.Data.prototype.setLiqprice = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string notional = 15;
 * @return {string}
 */
proto.common.model.ExHolds.Data.prototype.getNotional = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExHolds.Data} returns this
 */
proto.common.model.ExHolds.Data.prototype.setNotional = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string unrealizedProfit = 16;
 * @return {string}
 */
proto.common.model.ExHolds.Data.prototype.getUnrealizedprofit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExHolds.Data} returns this
 */
proto.common.model.ExHolds.Data.prototype.setUnrealizedprofit = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional int32 exchange = 1;
 * @return {number}
 */
proto.common.model.ExHolds.prototype.getExchange = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExHolds} returns this
 */
proto.common.model.ExHolds.prototype.setExchange = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated Data data = 2;
 * @return {!Array<!proto.common.model.ExHolds.Data>}
 */
proto.common.model.ExHolds.prototype.getDataList = function() {
  return /** @type{!Array<!proto.common.model.ExHolds.Data>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.common.model.ExHolds.Data, 2));
};


/**
 * @param {!Array<!proto.common.model.ExHolds.Data>} value
 * @return {!proto.common.model.ExHolds} returns this
*/
proto.common.model.ExHolds.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.common.model.ExHolds.Data=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.model.ExHolds.Data}
 */
proto.common.model.ExHolds.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.common.model.ExHolds.Data, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.model.ExHolds} returns this
 */
proto.common.model.ExHolds.prototype.clearDataList = function() {
  return this.setDataList([]);
};


goog.object.extend(exports, proto.common.model);
